import './App.css';
import EpisodeCarousel from './ui/EpisodeCarousel';

function App() {
  return <EpisodeCarousel />;
}

export default App;